import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";
import PillTextField from "@/app/shared/PillTextField";
import AspectSelectedLabel from "./AspectSelectedLabel";
import SearchIcon from "@mui/icons-material/Search";
import PillButton from "@/app/shared/PillButton";

// AJB: need an apply button to close the menu?
export default function AspectText({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const [searchValue, setSearchValue] = useState(value);
  return (
    <AspectSelectedLabel label="Keyword" selectedLabel={searchValue}>
      <PillTextField
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChange(searchValue);
          }
        }}
        placeholder="Keyword"
        isSelected={!!searchValue}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {searchValue && (
                  <>
                    {searchValue !== value ? (
                      <PillButton
                        primary
                        sx={{
                          height: "30px",
                          minWidth: "initial",
                          padding: 1,
                          marginRight: -1,
                        }}
                        onClick={() => onChange(searchValue)}
                      >
                        Submit
                      </PillButton>
                    ) : (
                      <ClearIcon
                        onClick={() => {
                          setSearchValue("");
                          onChange("");
                        }}
                        sx={{
                          backgroundColor: "grey.300",
                          borderRadius: "100px",
                          padding: 0.25,
                          cursor: "pointer",
                          marginRight: -0.25,
                        }}
                      />
                    )}
                  </>
                )}
              </InputAdornment>
            ),
          },
        }}
        size="small"
      />
    </AspectSelectedLabel>
  );
}
